import { useAuthPasswordRestoreMutation, useAuthSendEmailRepeatMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import GraphQLApiUtils from '@shared/api/graphql/utils';

import {
  RegisterResendEmailSendInputType,
  ForgotPasswordEmailSendInputType,
  RegisterResendEmailSendResultType,
  ForgotPasswordEmailSendResultType,
  UseEmailSendType,
} from './types';

// TODO: выпилить *Repeat*
const useEmailSend = (): UseEmailSendType => {
  const [sendEmailPureRepeatMutation, sendEmailPureRepeatMutationResult] = useAuthSendEmailRepeatMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const [sendPasswordRestoreMutation, sendPasswordRestoreMutationResult] = useAuthPasswordRestoreMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const sendEmailPureRepeatMutationRequest = async (input: RegisterResendEmailSendInputType) => {
    const mutationResult = await sendEmailPureRepeatMutation({ variables: { input } });
    return !!mutationResult.data?.sendEmailPureRepeat?.ok;
  };

  const sendPasswordRestoreMutationRequest = async (input: ForgotPasswordEmailSendInputType) => {
    const mutationResult = await sendPasswordRestoreMutation({ variables: { input } });
    return !!mutationResult.data?.passwordRestore?.ok;
  };

  const sendPasswordRestoreData = sendPasswordRestoreMutationResult.data?.passwordRestore;
  const hasErrors = !!sendPasswordRestoreData?.errors;
  const forgotPasswordEmailSendResultData: ForgotPasswordEmailSendResultType['data'] = {
    ok: sendPasswordRestoreData?.ok,
  };

  if (hasErrors) {
    forgotPasswordEmailSendResultData.errors = GraphQLApiUtils.errorsArrayToObject(sendPasswordRestoreData?.errors);
  }

  const sendEmailPureRepeatResult: RegisterResendEmailSendResultType = {
    error: sendEmailPureRepeatMutationResult.error,
    loading: sendEmailPureRepeatMutationResult.loading,
    called: sendEmailPureRepeatMutationResult.called,
    data: { ok: sendEmailPureRepeatMutationResult.data?.sendEmailPureRepeat?.ok },
  };

  const sendPasswordRestoreResult: ForgotPasswordEmailSendResultType = {
    error: sendPasswordRestoreMutationResult.error,
    loading: sendPasswordRestoreMutationResult.loading,
    called: sendPasswordRestoreMutationResult.called,
    data: forgotPasswordEmailSendResultData,
  };

  return [
    [sendEmailPureRepeatMutationRequest, sendPasswordRestoreMutationRequest],
    [sendEmailPureRepeatResult, sendPasswordRestoreResult],
  ];
};

export default useEmailSend;
